import styled, { css } from 'styled-components';

import Page from 'app/shared/containers/Page';
import { mediaMixin } from '@zillow/constellation';

// The following styles are targeting classNames that are created within the shared zillow/zrs-zillow-offers ErrorPage component.

export const StyledPage = styled(Page)`
    .testing_heading {
        font-size: 34px;
        line-height: 42px;

        ${mediaMixin('lg', css`
            font-size: 60px;
            line-height: 75px;
        `)}
    }

    && [class^="ErrorPage__CatWrapper"] {
        bottom: 670px;
        height: 250px;

        ${mediaMixin('sm', css`
            bottom: 580px;
            height: 400px;
        `)}


        ${mediaMixin('md', css`
            bottom: 430px;
            height: 400px;
        `)}

        ${mediaMixin('lg', css`
            bottom: 500px;
            height: 500px;
        `)}

        ${mediaMixin('xl', css`
            bottom: 550px;
            height: 600px;
        `)}
    }
`;
